// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import RouterView from './RouterView';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterView />
  </React.StrictMode>
);

reportWebVitals();
